export default "__VITE_ASSET__ByNZrkQD__"